const __LEH_firstclick = false;
const __LEH_hostname = 'vigrx.com';

const __LEH_preserved_consolelog = console.log.bind(console); // Create private console.log to avoid suppression
const __LEH_path = window.location.pathname + window.location.search;
const __LEH_redir_pattern = '^/ct/(\\d+)(?:\\?(.*))?$';
let __LEH_redir_regex = new RegExp('^' + __LEH_redir_pattern.replace(/\$([0-9]+)/g, '([^/]+)') + '/?$', 'i');
let __LEH_redir_match = __LEH_path.match(__LEH_redir_regex);
if (__LEH_redir_match) {
  let __LEH_redir_target = "/?u=$1";
  __LEH_redir_target = __LEH_redir_target.replace(/\$(\d+)/g, (_, groupIndex) => __LEH_redir_match[parseInt(groupIndex)]);
  if (window.location.search) {
    let _LEH_redir_target_qs = window.location.search;
    __LEH_redir_target += '&'+_LEH_redir_target_qs.substring(1);
  }
  window.location.replace(__LEH_redir_target);
}
if (__LEH_firstclick) {
  __LEHConsoleLog("fc mode");
} else {
  __LEHConsoleLog("lc mode");
}
let __LEH_oldCookie = null;
let __LEH_emptyAttr = { 'cd': null, 'src': null, 'u': null, 't1': null, 't2': null, 't3': null, 't4': null, 't5': null, 'acv': null, 'r': null, 'ref': null, 'host': null }; 
let __LEH_clickObj = structuredClone(__LEH_emptyAttr);
let __LEH_newClick = false;
let __LEH_cartToken = '';
try { 
  __LEH_oldCookie = JSON.parse(__LEH_getCookie('leh_sh'));
} catch(e) {
  __LEHConsoleLog('Old cookie parse error');
}
if (!__LEH_oldCookie) {
  __LEH_oldCookie = structuredClone(__LEH_emptyAttr);
}
if (__LEH_oldCookie && (__LEH_oldCookie.u || __LEH_oldCookie.cd || __LEH_oldCookie.src)) { __LEH_clickObj = structuredClone(__LEH_oldCookie); }
const __LEH_urlParams = new URLSearchParams(window.location.search);
let __LEH_shop = window.location.href.match(/\?(\d+)/);
let rapU = null;
if (__LEH_shop && __LEH_shop[1]) {
  __LEHConsoleLog('Shop link detected');
  rapU = __LEH_shop[1];
  __LEH_clickObj.u = __LEH_shop[1]; 
  __LEH_clickObj.t1 = null;
  __LEH_clickObj.t2 = null;
  __LEH_clickObj.t3 = null;
  __LEH_clickObj.t4 = null;
  __LEH_clickObj.t5 = null;
  __LEH_clickObj.acv = null;
  __LEH_clickObj.r = null;
  __LEH_clickObj.ref = document.referrer;
  __LEH_clickObj.src = null;
}
if (__LEH_urlParams && __LEH_urlParams.size > 0) {
  let utms = __LEH_urlParams.get('utm_source');
  let utmc = __LEH_urlParams.get('utm_content');
  let utmm = __LEH_urlParams.get('utm_medium');
  let utmct = __LEH_urlParams.get('utm_campaign_type');
  let utmFound = false;
  if (utms && utmct && utms.toLowerCase() == 'google') {
    if (utmct.toLowerCase() == 'shopping') {
      utmFound=true;
      __LEH_clickObj.u = '498032';
    } else if (utmct.toLowerCase() == 'pmax') {
      utmFound=true;
      __LEH_clickObj.u = '994341';
    } else if (utmct.toLowerCase() == 'search') {
      utmFound=true;
      __LEH_clickObj.u = '297282';
    //} else if (utmm && utmm.toLowerCase() == 'product_sync' && utmc.toLowerCase() == 'sag_organic') {
    //  utmFound=true;
    //  __LEH_clickObj.u = '498032';
    }
    if (utmFound) {
      __LEHConsoleLog('Shop link via UTM detected');
      __LEH_clickObj.t1 = null;
      __LEH_clickObj.t2 = null;
      __LEH_clickObj.t3 = null;
      __LEH_clickObj.t4 = null;
      __LEH_clickObj.t5 = null;
      __LEH_clickObj.acv = null;
      __LEH_clickObj.r = null;
      __LEH_clickObj.ref = document.referrer;
      __LEH_clickObj.src = null;
    }
  }
  if (__LEH_urlParams.get('u')) { 
    __LEH_clickObj.u = __LEH_urlParams.get('u');
    rapU = __LEH_urlParams.get('u');
    if (__LEH_urlParams.get('nc') != 1) {
      __LEH_newClick=true;
    }
  } else if (__LEH_urlParams.get('unc')) {
    __LEH_clickObj.u = __LEH_urlParams.get('unc');
    rapU = __LEH_urlParams.get('unc');
  }
  if (__LEH_urlParams.get('t')) {
    __LEH_clickObj.t1 = __LEH_urlParams.get('t');  
  } else {
    __LEH_clickObj.t1 = __LEH_urlParams.get('t1');
  }
  __LEH_clickObj.t2 = __LEH_urlParams.get('t2');
  __LEH_clickObj.t3 = __LEH_urlParams.get('t3');
  __LEH_clickObj.t4 = __LEH_urlParams.get('t4');
  __LEH_clickObj.t5 = __LEH_urlParams.get('t5');
  __LEH_clickObj.acv = __LEH_urlParams.get('acv');
  __LEH_clickObj.r = __LEH_urlParams.get('r');
  __LEH_clickObj.ref = document.referrer;
  __LEH_clickObj.host = __LEH_hostname;
  __LEH_clickObj.is_unique = true;
  if (__LEH_urlParams.get('cd')) { 
    __LEH_clickObj.cd = __LEH_urlParams.get('cd'); 
    __LEH_oldCookie.cd = __LEH_urlParams.get('cd'); 
  }
  if (__LEH_urlParams.get('src')) { 
    __LEH_clickObj.src = __LEH_urlParams.get('src'); 
    if (__LEH_clickObj.src == 'cpe' || __LEH_clickObj.src == 'cp' || __LEH_clickObj.src == 'rebill') {
      if (__LEH_urlParams.get('hostid')) {
        __LEH_clickObj.host = __LEH_urlParams.get('hostid');
      }
    }
  }
  if (rapU) {
    let oldRAP = __LEH_oldCookie.rap || "";
    let oldRAPVals = oldRAP.split(':').filter(Boolean);
    let newRAP = [rapU].concat(oldRAPVals).slice(0, 5).join(':');
    __LEH_clickObj.rap = newRAP;
    __LEH_oldCookie.rap = newRAP;
  }
  if (__LEH_clickObj.u || __LEH_clickObj.cd || __LEH_clickObj.src) { 
    if (__LEH_clickObj.u && __LEH_oldCookie && __LEH_oldCookie.u && __LEH_oldCookie.u == __LEH_clickObj.u) { 
      __LEH_clickObj.is_unique=false; 
    }
    let cookieVals = structuredClone(__LEH_oldCookie);
    if (!__LEH_firstclick || !__LEH_oldCookie || !__LEH_oldCookie.u) {
      cookieVals = structuredClone(__LEH_clickObj);
    }
    __LEH_setCookie('leh_sh',JSON.stringify(cookieVals),1825);
    if (!__LEH_firstclick || !__LEH_oldCookie || !__LEH_oldCookie.u) {
      __LEH_storeCart(structuredClone(__LEH_clickObj),__LEH_newClick);
    } else {
      __LEH_storeCart(structuredClone(__LEH_oldCookie),__LEH_newClick);
    }
  } else if (__LEH_urlParams.get('dtc')) {
    __LEH_DirectToCart(__LEH_urlParams.get('dtc'));
  } else if (__LEH_urlParams.get('r')) {
    __LEH_redirect(__LEH_urlParams.get('r'),__LEH_hostname);
  }
  if (__LEH_clickObj.u || __LEH_oldCookie.u) {
    if (!__LEH_urlParams.get('dtc')) {
      setTimeout(() => {
        __LEHConsoleLog('Shield Timeout');
        __LEH_attributeShield();
      },5000);
    }
  }
} else if (__LEH_oldCookie && __LEH_oldCookie.u) { 
  __LEH_checkAttr(__LEH_oldCookie); 
}
function __LEH_clickthrough(obj) {
  if (obj) {
    if (__LEH_urlParams.get('unc')) { obj.nc=1; }
    obj.url=window.location.href;
    fetch('https://cc.sllhlth.com/a/c', {
      method: 'POST',
      headers: {'Content-Type': 'application/json','Accept': 'application/json'},
      body: JSON.stringify(obj)
    })
    .then(response => response.json())
    .then((data) => {
      if (data['message'] && data['message'] == 'banned') {
        window.location.replace('https://www.sellhealth.com/banneduser.php');
      } else if (data['r']) {
        window.location.replace('https://'+data['r']);
      } else {
        __LEHConsoleLog('SH Click Recorded: '+data['message']);
        if (__LEH_urlParams.get('dtc')) {
          __LEH_DirectToCart(__LEH_urlParams.get('dtc'));
        }
      }
    });
  }  
}
function __LEH_redirect(r,h) {
  fetch('https://cc.sllhlth.com/a/r', {
    method: 'POST',
    headers: {'Content-Type': 'application/json','Accept': 'application/json'},
    body: JSON.stringify({ 'r': r, 'host': h })
  })
  .then(response => response.json())
  .then((data) => {
    if (data['r']) {
      window.location.replace('https://'+data['r']);
    }
  });  
}
async function __LEH_storeCart(obj,withClick=false,onlyStore=false) {
  let attrObj = {};
  for (const [k, v] of Object.entries(obj)) {
    if (k != 'is_unique') {
      attrObj['leh_'+k] = v;
    }
  }
  await fetch(window.Shopify.routes.root + 'cart/update.js?1', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({ attributes: attrObj })
  })
  .then(response => response.json())
  .then((data) => {
    __LEHConsoleLog('Attributes stored in cart');
    if (!onlyStore) {
      if (withClick) {
        __LEH_clickthrough(__LEH_clickObj); 
      } else if (__LEH_urlParams.get('dtc')) {
        __LEH_DirectToCart(__LEH_urlParams.get('dtc'));
      } else if (__LEH_urlParams.get('r')) {
        __LEH_redirect(__LEH_urlParams.get('r'),__LEH_hostname);
      }
    }
  });  
}
async function __LEH_checkAttr(obj) {
  fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
  .then(response => response.json())
  .then(data => {
    let oldUser = null; 
    if (data.attributes.leh_u) {
      oldUser = data.attributes.leh_u;
    }
    if (obj.u && !oldUser) {
      if (!__LEH_urlParams.get('cd')) {
        obj.cd = null;
      }
      __LEHConsoleLog('Restoring cart attributes from cookie values');
      __LEH_setCookie('leh_sh',JSON.stringify(obj),1825);
      __LEH_storeCart(obj,false,true);
    } else {
      __LEHConsoleLog('Attributes match cookie');
    }
  });  
}
function __LEH_showAllCart() { 
  fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
  .then(response => response.json())
  .then(data => { __LEHConsoleLog(data); }); 
}
function __LEH_clearCartAttr() { __LEH_storeCart(__LEH_emptyAttr); __LEHConsoleLog('Cart cleared'); }
function __LEH_setCookie(name, value, days) { var expires = ""; if (days) { var date = new Date(); date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); expires = "; expires=" + date.toUTCString(); } document.cookie = name + "=" + (value || "") + expires + "; path=/"; __LEHConsoleLog('Cookie updated'); }
function __LEH_getCookie(name) { var nameEQ = name + "="; var ca = document.cookie.split(';'); for (var i = 0; i < ca.length; i++) { var c = ca[i]; while (c.charAt(0) == ' ') c = c.substring(1, c.length); if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length); } return null; }
function __LEH_TimerCheck(s,e) {
  let isok = true;
  if (!s) { s = '2025-01-01 00:00:00'; }
  if (!e) { s = '2099-01-01 00:00:00'; }
  const d = new Date(new Date().toLocaleString("en-US", {timeZone: "America/Los_Angeles"}));
  const date = d.getFullYear()+String(d.getMonth()+1).padStart(2,'0')+String(d.getDate()).padStart(2,'0');
  const time = d.toTimeString().split(' ')[0];
  const tnow = parseInt((date+' '+time).replace(/\D/g,""));
  const tactive = parseInt(s.replace(/\D/g,""));
  const tdeactive = parseInt(e.replace(/\D/g,""));
  if (tnow < tactive || tnow > tdeactive) { isok = false; }
  return isok;
}
function __LEH_DiscountCheck(c) {
  if (!c) { return true; }
  let dc = __LEH_getCookie('discount_code');
  let isok = false;
  if (!dc) { dc = '';}
  if (c.toLowerCase() == dc.toLowerCase()) { isok = true; }
  return isok;
}
async function __LEH_DirectToCart(c) {
  await __LEH_attributeShield();
  let refs = c.split(':');
  let p = refs[0];
  let q = parseInt(refs[1]);
  if (p && q) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({'items':[{'id':p,'quantity':q}]})
    })
    .then(response => response.json())
    .then((data) => {
      __LEH_jumpToCart(c);
    });  
  }
}
function __LEH_jumpToCart(c) {
  if (__LEH_cartToken) { return __LEH_cartToken; }
  fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' })
  .then(response => response.json())
  .then(data => {
    let qs = '';
    let targetURL = 'https://'+__LEH_hostname+'/cart/'+c;
    for (const [k, v] of Object.entries(data.attributes)) {
      if (qs) { qs += '&'; }
      qs += 'attributes['+k+']='+v;
    }
    if (qs) { targetURL += '?'+qs; }
    window.location.replace(targetURL);
  });  
}
function __LEHConsoleLog(msg) {
  switch(typeof(msg)) {
    case 'string':
      __LEH_preserved_consolelog('%c[LEH]: '+msg,'display: inline-block;font-size: 14px;background: linear-gradient(to right,rgb(255, 153, 0),rgb(204, 93, 208),rgb(44, 33, 197));color: white;padding: 4px;border-radius: 4px;');
      break;
    default:
      __LEH_preserved_consolelog(msg);
  }
}
async function __LEH_getUserIP() {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    console.log(data);
    return data.ip;
  } catch(error) {
    __LEHConsoleLog('Error grabbing IP: '+error);
    return null;
  }
}
async function __LEH_authCheck(event) {
  event.preventDefault();
  const userIP = await __LEH_getUserIP();
  if (userIP) {
    __LEHConsoleLog("User's IP Address: "+userIP);
    var url = 'https://data-api.dmcontact.com/api/authenticity';
    document.getElementById('authenticity-check').disabled = true;
    setTimeout(() => document.getElementById('authenticity-check').disabled = false, 5000);
    let formData = new FormData(document.getElementById('counterfeit-check'));
    let requestData = Object.fromEntries(formData.entries());
    if (requestData.code) {
      requestData.code = requestData.code.replace(/\s+/g, '');
      document.getElementById('authenticity-code').value = requestData.code;
    }
    document.querySelectorAll('.authenticity-response').forEach(element => {
      element.style.display = 'none';
    });
    if (!requestData.code) {
      document.getElementById('authcheck-missingcode').style.display = 'block';
    } else {
      try {
        const payload = {
          code: requestData.code,
          ip: userIP,
          rtype: 'json',
          host: __LEH_hostname,
          source: '',
          rip: userIP,
          product_id: 48
        };
        const formBody = new URLSearchParams(payload).toString();
        await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: formBody
        })
        .then(response => response.json())
        .then((data) => {
          console.log(data);
          if (data.status) {
            document.getElementById('authcheck-' + data.status).style.display = 'block';
          }
        })
        .catch(error => {
          document.getElementById('authcheck-error').style.display = 'block';
        });
      } catch (error) {
        document.getElementById('authcheck-error').style.display = 'block';
      }
    }
  } else {
    __LEHConsoleLog('Cannot get user IP');
    document.getElementById('authcheck-error').style.display = 'block';
  }
}
async function __LEH_attributeShield() {
  let checkCookie = null;
  try { 
    checkCookie = JSON.parse(__LEH_getCookie('leh_sh'));
  } catch(e) {
    __LEHConsoleLog('Old cookie parse error');
  }
  if (checkCookie && checkCookie.u) {
    await __LEH_checkAttr(checkCookie);
  }
  return;
}